import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogPaper from '../DialogPaper';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    width: 150,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
  },
  title: {
    marginTop: theme.spacing(3),
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
    minWidth: 200,
  },
  subtext: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
    fontSize: 21,
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 0.5)',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmRedeem: () => void;
  rewardTitle: string;
};

export default function RedeemRewardDialog({
  onClose,
  open,
  confirmRedeem,
  rewardTitle,
}: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={DialogPaper}>
      <div className={classes.cardContainer}>
        <Typography variant="h5" className={classes.title} gutterBottom>
          Redeem Reward?
        </Typography>
        <Typography variant="h4" className={classes.title} gutterBottom>
          {rewardTitle}
        </Typography>
        <Button
          color="primary"
          className={classes.buttonContainer}
          onClick={() => confirmRedeem()}
        >
          CONFIRM
        </Button>
      </div>
    </Dialog>
  );
}
